import axios, { type AxiosError } from "axios";

import HttpError from "./HttpError";

interface IApiErrorResponse {
  errors: unknown;
  Message: string;
}

function axiosErrorHandler(error: unknown, fallbackMessage: string): HttpError {
  const errorObject = error as Error | AxiosError;
  // eslint-disable-next-line no-console
  console.error(error);
  let errors: string[] = [fallbackMessage];
  if (axios.isAxiosError(errorObject)) {
    const responseData = errorObject.response?.data as IApiErrorResponse;
    if (responseData?.errors) {
      errors = Object.values(responseData?.errors);
    }
    if (responseData?.Message) {
      errors = [responseData?.Message];
    }
    if (errorObject.message === "Network Error") {
      errors = [errorObject.message];
    }
  }
  return new HttpError(errors);
}

export default axiosErrorHandler;
